import React from 'react';
import { type CountdownRenderProps } from 'react-countdown';
import { Tooltip } from '@mantine/core';

function formatNumber(val: number) {
  return val.toString().padStart(2, '0');
}

const MintCountDown: React.FC<CountdownRenderProps> = ({
  days,
  hours,
  minutes,
  seconds,
  completed,
}) => {
  if (completed) {
    return <span className="text-green">Minting</span>;
  }
  return (
    <>
      <span className="text-green">Open in</span>
      <div className="flex gap-2 !ml-2">
        <div className="cursor-default" data-state="closed">
          <Tooltip label="Days" color="dark">
            <div className="!w-8 !h-8 cursor-default bg-secondary flex items-center justify-center rounded  font-bold text-white font-mono">
              <span>{formatNumber(days)}</span>
            </div>
          </Tooltip>
        </div>
        <div className="cursor-default" data-state="closed">
          <Tooltip label="Hours" color="dark">
            <div className="!w-8 !h-8 cursor-default bg-secondary flex items-center justify-center rounded  font-bold text-white font-mono">
              <span>{formatNumber(hours)}</span>
            </div>
          </Tooltip>
        </div>
        <div className="cursor-default" data-state="closed">
          <Tooltip label="Minutes" color="dark">
            <div className="!w-8 !h-8 cursor-default bg-secondary flex items-center justify-center rounded  font-bold text-white font-mono">
              <span>{formatNumber(minutes)}</span>
            </div>
          </Tooltip>
        </div>
        <div className="cursor-default" data-state="closed">
          <Tooltip label="Seconds" color="dark">
            <div className="!w-8 !h-8 cursor-default bg-secondary flex items-center justify-center rounded  font-bold text-white-1 font-mono">
              <span>{formatNumber(seconds)}</span>
            </div>
          </Tooltip>
        </div>
      </div>
    </>
  );
};

export default MintCountDown;
